<template>
    <div>
        <el-button @click="dialogVisible = true" type="danger">币种批量设置</el-button>
        <el-button @click="chinaDialogVisible = true" type="danger">链设置</el-button>


        <el-dialog :visible.sync="dialogVisible" @close="closeDialog" @open="openDialog" title="币种批量设置" width="1200px">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
            </el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="chexkCode" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="(info,index) in logoInfo" :label="info.coinType" :key="index"
                             style="width: 150px;margin-left: 0px;overflow: hidden;margin-bottom: 5px">{{info.coinType}}
                </el-checkbox>
            </el-checkbox-group>

            <div slot="footer" style="text-align: center">
                <div style="margin-bottom: 10px">
                    <el-button type="primary" @click="handleBatchSave(true,null)">开启充值</el-button>
                    <el-button type="primary" @click="handleBatchSave(null,true)">开启提现</el-button>
                </div>
                <div>
                    <el-button @click="handleBatchSave(false,null)">关闭充值</el-button>
                    <el-button @click="handleBatchSave(null,false)">关闭提现</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="chinaDialogVisible" @close="closeDialog" title="链设置" width="500px">
            <el-select v-model="chain" placeholder="请选择" style="width: 100%">
                <el-option label="ERC20" value="MULTI_ERC20"></el-option>
                <el-option label="TRC20" value="MULTI_TRC20"></el-option>
            </el-select>

            <div slot="footer" style="text-align: center">
                <div style="margin-bottom: 10px">
                    <el-button type="primary" @click="handleChainBatchSave(true,null)">开启充值</el-button>
                    <el-button type="primary" @click="handleChainBatchSave(null,true)">开启提现</el-button>
                    <el-button @click="handleChainBatchSave(false,null)">关闭充值</el-button>
                    <el-button @click="handleChainBatchSave(null,false)">关闭提现</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import api from '../../api';
    import {mapState, mapActions} from 'vuex';

    export default {
        name: 'CurrencyBatch',
        data() {
            return {
                dialogVisible: false,
                chinaDialogVisible: false,
                checkAll: false,
                isIndeterminate: true,
                chexkCode: [],
                chain:""
            };
        },
        computed: {
            ...mapState('currencySetting', ['logoInfo'])
        },
        methods: {
            ...mapActions('currencySetting', ['getLogoInfo']),
            closeDialog() {
                this.chexkCode = [];
                this.chain = "";
                this.isIndeterminate = true;
                this.checkAll = false;
                this.dialogVisible = false;
                this.chinaDialogVisible = false;
            },
            openDialog() {
                this.getLogoInfo();
            },
            handleBatchSave(supportDeposit, supportWithdraw) {
                if (this.chexkCode.length <= 0) {
                    this.$message.success('请选择币种!');
                    return;
                }

                let tipMsg = supportDeposit == true ? "确认所选币种，开启充值" : (supportDeposit == false ? "确认所选币种，关闭充值" :
                    (supportWithdraw == true ? "确认所选币种，开启提现" : (supportWithdraw == false ? "确认所选币种，关闭提现" : "")));

                this.$confirm(tipMsg, '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateCoinBatch({
                        coinList: this.chexkCode.join(","),
                        supportDeposit: supportDeposit,
                        supportWithdraw: supportWithdraw
                    }).then(({data}) => {
                        this.$message.success('操作成功!');
                        this.$emit("refresh", {page: 1});
                    });
                }).catch(() => {
                });
            },
            handleChainBatchSave(supportDeposit, supportWithdraw){
                if (this.chain == "") {
                    this.$message.success('请选择链!');
                    return;
                }

                let tipMsg = supportDeposit == true ? "确认所选链，开启充值" : (supportDeposit == false ? "确认所选链，关闭充值" :
                    (supportWithdraw == true ? "确认所选链，开启提现" : (supportWithdraw == false ? "确认所选链，关闭提现" : "")));

                this.$confirm(tipMsg, '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateChainCoinBatch({
                        chain: this.chain,
                        supportDeposit: supportDeposit,
                        supportWithdraw: supportWithdraw
                    }).then(({data}) => {
                        this.$message.success('操作成功!');
                        this.$emit("refresh", {page: 1});
                    });
                }).catch(() => {
                });
            },
            handleCheckAllChange(val) {
                this.chexkCode = val ? this.logoInfo.map((v) => v.coinType) : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = this.chexkCode.length;
                this.checkAll = checkedCount === this.logoInfo.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.logoInfo.length;
            }
        }
    };
</script>

<style lang="less" scoped>
    .url-wrap {
        display: flex;
        align-items: flex-start;
        padding-bottom: 10px;

        .url-text {
            line-height: 40px;
            margin-right: 8px;
        }

        .upload {
            flex: 1;
        }
    }

    .logo {
        display: flex;
        align-items: center;

        .logo-img {
            margin-right: 8px;
            display: inline-block;
            width: 32px;
            height: 32px;
            background-size: 32px;
        }
    }
</style>
